document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.tn-hero video').forEach(v=>{v.muted=true;v.setAttribute('playsinline','');v.play().catch(()=>{})});

  const motion=new IntersectionObserver(entries=>entries.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('tn-in');motion.unobserve(e.target)}
  }),{threshold:.22});

  document.querySelectorAll('.tn-kinetic,.tn-motion-type,.tn-motion-slide,.tn-scenic-drop').forEach(el=>motion.observe(el));

  /* Any major heading not explicitly animated inherits direction from its actual layout position. */
  document.querySelectorAll('.tn-sec h2,.tn-objects h2,.tn-feature-head h2').forEach(el=>{
    if(el.classList.contains('tn-motion-slide') || el.classList.contains('tn-scenic-drop')) return;
    const r=el.getBoundingClientRect();
    const center=r.left+r.width/2;
    el.classList.add('tn-auto-brake');
    el.dataset.tnSide=center < window.innerWidth/2 ? 'left' : 'right';
    motion.observe(el);
  });

  const scenic=document.querySelector('.tn-scenic-drop');
  if(scenic){scenic.addEventListener('animationstart',()=>{setTimeout(()=>{const zone=scenic.closest('section');if(zone){zone.classList.add('tn-scenic-hit');setTimeout(()=>zone.classList.remove('tn-scenic-hit'),180)}},410)},{once:true})}

  /* Exactly one KIDOKU. Trigger by the stamp section entering the lower reading zone; no impossible tall-section ratio. */
  const stamp=document.querySelector('.tn-kidoku');
  if(stamp){
    const zone=stamp.closest('.tn-read-zone');
    let fired=false;
    const read=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(!fired && e.isIntersecting){
        fired=true;
        zone.classList.add('tn-read','tn-stamp-hit');
        setTimeout(()=>zone.classList.remove('tn-stamp-hit'),260);
        read.disconnect();
      }
    }),{threshold:0,rootMargin:'-38% 0px -18% 0px'});
    read.observe(zone);
  }
});
